export const API_V2 = 'Api_v2'
